import { validateCsvData } from "./validateCsvData";

export default validateCsvData;
